import { AlertTriangle } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminComplaints() {
  return (
    <CollectionAdmin
      path="complaints"
      title="Prigovori"
      subtitle="Prijave sadržaja ili komentara"
      icon={AlertTriangle}
      testid="admin-complaints"
      fields={[
        { key: 'name', label: 'Ime prijavitelja' },
        { key: 'email', label: 'Email prijavitelja' },
        { key: 'target_type', label: 'Tip prijave (article/comment/user)' },
        { key: 'target_id', label: 'ID cilja' },
        { key: 'reason', label: 'Razlog', type: 'textarea' },
        { key: 'status', label: 'Status (new/investigating/resolved)' },
      ]}
    />
  );
}
